import React, { useRef, useEffect } from 'react';
import { PerspectiveCamera, OrbitControls } from '@react-three/drei';
import { useThree } from '@react-three/fiber';

const PerspectiveCameraSetup = () => {
  const cameraRef = useRef();
  const { set, gl } = useThree();

  useEffect(() => {
    if (cameraRef.current) {
      set({ camera: cameraRef.current });
    }
  }, [set]);

  return (
    <>
      <PerspectiveCamera
        ref={cameraRef}
        makeDefault
        fov={80}               // Field of view
        aspect={window.innerWidth / window.innerHeight}  // Aspect ratio
        near={0.1}             // Near clipping plane
        far={1000}             // Far clipping plane
        position={[5, 5, 5]}   // Initial position
      />
      {cameraRef.current && <OrbitControls args={[cameraRef.current, gl.domElement]} />}
    </>
  );
};

export default PerspectiveCameraSetup;
